<div class="container mb-5 wrapper-content payment-success-wrapper">
  <h1 class="text-center mt-3">Payment Successful</h1>

  <div class="right-side">
    <div class="row mt-3">
      <div class="top-success">
        <div class="row">
          <div class="col-md-6">
            <div class="datas">
              <img class="right-img" src="assets/social/success-right.svg" alt="">
              <p class="new-text text-center">
                Congratulations! Your transaction has been completed successfully.
              </p>
            </div>
          </div>
          <div class="col-md-6 d-flex justify-content-center align-items-center">
            <img class="left-img" src="assets/svg/right-sucess.svg" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="success-actions" *ngIf="paymentList =='product'">
    <button class="add-cart" [routerLink]="['/customer-order-history']">View Orders</button>
  </div>
  <div class="success-actions" *ngIf="paymentList =='booking'">
    <button class="add-cart" [routerLink]="['/customer-service-request-list-table']">View Bookings</button>
  </div>
  <div class="success-actions" *ngIf="paymentList =='wallet'">
    <button class="add-cart" [routerLink]="['/customer-wallet']" (click)="setReturningFlag()">Continue</button>
  </div>
</div>